import React, { useState } from 'react';

import ClassUsagePageHeader from './components/Header';
import ClassUsageTable from './components/Table';
import { ClassUsageSearchFilters, initialSearchFilters } from './SearchFilters';

const ClassUsage = (): JSX.Element => {
  const [searchFilters, setSearchFilters] = useState<ClassUsageSearchFilters>(initialSearchFilters);

  return (
    <>
      <ClassUsagePageHeader
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        initialSearchFiltersValue={initialSearchFilters}
      />
      <ClassUsageTable searchFilters={searchFilters} />
    </>
  );
};

export default ClassUsage;
